jQuery(function($){
	$('.sc-field-editor .field.tel input[type=tel]').on('change', function(){
		let input = $(this);
		let data = {
			action: 'choralorg_ajax_update_phone_format',
			value: $(this).val()
		};
		$.post('/wp-admin/admin-ajax.php', data, function(response){
			input.val(response.trim());
		});
	});
});